/**
 * This is a thin wrapper over toast-base, a notification component.
 * It differs from toast-base in that it does not support `isError`.
 */
import ToastBase, {type SharedToastProps} from "./toast-base.tsx";

type ToastProps = SharedToastProps & {
    // Time in ms when to automatically close the toast notification
    autoTimeout?: number;
    // Should not specify an `isError` prop. Use ErrorToast instead
    isError?: undefined;
};

export const Toast = (props: ToastProps) => {
    return <ToastBase {...props} />;
};
